<template>
	<div style="width: 100%;" :style="{
		minHeight:`calc(100vh - ${placeNavHeight}px)`
	}">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div v-if="(!classifyData && type == 'design') || !goodsDataList"
			style="padding: 10px;width: 100%;font-size: 16px;">请添加测试商品</div>
		<div v-if="goodsDataList" style="width: 100%;height: 100%;">
			<div v-if="classifyData" style="display: flex;width: 100%;height: 100%;">
				<div v-if="classifyData && classifyData.all_categories.length > 0 && equipment == 'pc' && selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show"
					style="margin-right: 4px;width: 220px;display: flex;flex-direction: column;align-items: center;"
					:style="{
						...getBorder(),
						...getBoderRadius()
					}">
					<div style="font-weight: bold;width: 100%;margin-top: 6px;margin-left: 6px;" :style="{
						color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.titleColor,
						fontSize:(selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie + 1) + 'px'
					}">{{$t('h.classify')}}</div>
					<el-tree node-key="url_name" auto-expand-parent class="el-tree"
						:default-expanded-keys="[selectCategoriesId]" :expand-on-click-node="false"
						@node-click="handleNodeClick" style="width: 210px;margin-top: 12px;"
						:data="classifyData.all_categories" :props="defaultProps">
						<template slot-scope="{ node, data }">
							<span class="custom-tree-node">
								<span
									:style="{color:getColor(data),fontWeight:selectCategoriesId == data.url_name?'bold':'',fontSize:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie + 'px',fontFamily:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzieFamily }">
									<!-- <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 180px;">{{ data.name }}</div> -->
									{{ data.name }}
								</span>
							</span>
						</template>
					</el-tree>
					<div :style="{
						color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.titleColor,
					 	fontSize:(selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie + 1) + 'px'
					 }" v-if="classifyData && classifyData.filter_data.price.min != classifyData.filter_data.price.max && show"
						style="font-weight: bold;width: 100%;margin-top: 20px;margin-left: 6px;">{{$t('h.price')}}</div>
					<div style="width: 180px;" :style="{
							fontSize:(selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie + 1) + 'px'
						}" v-if="classifyData && show && classifyData.filter_data.price.min != classifyData.filter_data.price.max">
						<el-slider :style="{
							'--sliderColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.priceSliderColor
						}" @change="changePrice" input-size="mini" style="width: 180px;" :step="0.01" range
							:min="classifyData.filter_data.price.min" :max="classifyData.filter_data.price.max"
							v-model="prices"></el-slider>
						<div :style="{
							color:getCheckboxColor(false),
						}" style="display: flex;align-items: center;justify-content: space-between;width: 180px;">
							<div>{{classifyData.filter_data.price.select_min}}</div>
							<div>{{classifyData.filter_data.price.select_max}}</div>
						</div>
					</div>
					<div v-if="classifyData" style="width: 100%;margin-top: 20px;">
						<div style="margin-top: 12px;margin-left: 6px;" :key="index"
							v-for="(item,index) in classifyData.filter_data.attr">
							<div style="font-weight: bold;" :style="{
								color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.titleColor,
						fontSize:(selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie + 1) + 'px'
					}">
								{{item.name}}
							</div>
							<div v-if="type == 'design'" @click="changeAttr(vItem,item)" style="margin: 8px;"
								v-for="(vItem,vIndex) in item.values" :key="vIndex">
								<el-checkbox :style="{
									'--checkboxColor':getCheckboxColor(true),
									color:getCheckboxColor(vItem.selected),
									
								}" v-model="vItem.selected"><span :style="{
										fontSize:(selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie - 1) + 'px'
									}">{{vItem.name}}</span></el-checkbox>
							</div>
							<div v-if="type == 'build'" style="margin: 8px;" v-for="(vItem,vIndex) in item.values"
								:key="vIndex">
								<el-checkbox @change="changeAttr(vItem,item)" :style="{
									'--checkboxColor':getCheckboxColor(true),
									color:getCheckboxColor(vItem.selected),
									
								}" v-model="vItem.selected"><span :style="{
										fontSize:(selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie - 1) + 'px'
									}">{{vItem.name}}</span></el-checkbox>
							</div>
						</div>
					</div>
				</div>
				<div style="display: flex;flex-direction: column;align-items: center;width: 100%;">
					<div style="margin-top: 10px;display: flex;justify-content: space-between;width: 100%;">
						<div> </div>
						<div style="display: flex;align-items: center;margin-right: 10px;">
							<div style="font-size: 14px;">
								1-{{searchParms.per_page}} <span style="margin-left: 6px;">{{$t('h.allNum')}}:{{total}}
								</span>
							</div>
							<div style="margin-left: 10px;">
								<el-select @change="changePages" size="mini" style="width: 80px;"
									v-model="searchParms.per_page">
									<el-option v-for="item in per_pages" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</div>
							<div style="margin-left: 10px;">
								<el-select @change="changeSort" :style="{
									width:equipment == 'pc'? '160px':'110px'
								}" size="mini" v-model="searchParms.sort">
									<el-option v-for="(item,index) in options" :key="index" :label="item.name"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>
					<div :style="getColumns()"
						style="width: 100%;display: grid;margin-top: 10px;justify-content: space-around;">
						<single-goods style="max-width: 100%;" v-for="(item,index) in goodsDataList" :key="index"
							:goodsData="{
								...item,
								image_format:item.images[0]
							}" :equipment="equipment" :selectdItem="selectdItem" :systemConfig="systemConfig" :type="type"></single-goods>
					</div>
					<div style="margin-top: 20px;" v-if="goodsDataList.length > 0">
						<div :style="{
							flexDirection:equipment == 'pc'?'row':'column'
						}" style="display: flex;align-items: center;">
							<el-pagination :page-size="searchParms.per_page" @current-change="currentChange" :style="{
								'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
								'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
							}" layout="prev, pager, next" :total="total">
							</el-pagination>
							<div :style="{
								color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
							}" style="font-size: 13px;">{{$t('h.allNum')}} {{total}} </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		getCategories,
		getDesignProducts,
		getDesignGetAllCategory,
		getSetDesignCategoriesData
	} from '../../api/all.js'
	import singleGoods from './singleGoods.vue'
	export default {
		components: {
			singleGoods
		},
		props: {
			placeNavHeight: {
				type: Number,
				default: 0
			},
			guides: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},

		watch: {
			$route: {
				immediate: true,
				deep: true,
				handler: async function(to, from) {
					// 最多三个 已经存在一个
					console.log('to, from', to, from)
					// 初始化才加载
					if (this.type == 'build') {
						this.url_name = to.params.id
						this.selectCategoriesId = this.url_name
						this.getData(this.url_name)
					}
				}
			}
		},

		data() {
			return {
				options: [{
						name: this.$t('h.defaultTit'),
						value: ""

					},
					{
						name: this.$t('h.salesLowToHigh'),
						value: "sort=products.sales&order=asc"

					},
					{
						name: this.$t('h.salesHighToLow'),
						value: "sort=products.sales&order=desc"


					},
					{
						name: this.$t('h.nameAtoZ'),
						value: "sort=pd.name&order=asc"

					},
					{
						name: this.$t('h.nameZtoA'),
						value: "sort=pd.name&order=desc"

					},
					{
						name: this.$t('h.priceLowtoHeight'),
						value: "sort=product_skus.price&order=asc"
					},
					{
						name: this.$t('h.priceHeighttoLow'),
						value: "sort=product_skus.price&order=desc"
					}
				],
				total: 0,
				searchParms: {
					page: 1,
					per_page: 20,
					sort: "",
					price: '',
					attr: ''
				},
				attrs: {},
				prices: [],
				loading: false,
				goodsData: {},
				classifyData: null,
				defaultProps: {
					children: 'children',
					label: 'name'
				},
				selectCategoriesId: "",
				goodsDataList: [],
				per_pages: [],
				url_name: "",
				show: true
			}
		},
		async mounted() {
			console.log('this.selectdItem', this.selectdItem)
			if (this.type == 'design') {
				await this.getData(this.url_name)
			}
		},
		methods: {
			changeAttr(e, item) {
				console.log('changeAttr', e)
				if (this.type != 'build') {
					e.selected = !e.selected;
				}
				this.attrs = {}
				if (e.selected) {
					this.attrs[item.id + item.name] = `${item.id}:${e.id}`
				} else {
					delete this.attrs[item.id + item.name]
				}

				let str = ""
				for (let i in this.attrs) {
					if (str == '') {
						str = this.attrs[i]
					} else {
						str = str + '|' + this.attrs[i]
					}

				}
				this.searchParms.attr = str
				this.getGoods(this.url_name)
			},
			changePrice(e) {
				console.log('changePrice', e)
				this.searchParms.price = e[0] + '-' + e[1]
				this.getGoods(this.url_name)
			},
			changePages() {
				this.getGoods(this.url_name)
			},
			changeSort(e) {
				console.log('changeSorte', e)
				this.getGoods(this.url_name)
			},
			currentChange(e) {
				this.searchParms.page = e
				// this.searchParms.sort = e
				this.getGoods(this.url_name)
			},
			getBoderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius[0]}px ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius[1]}px ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius[2]}px ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius[3]}px`
				return style
			},
			getBorder() {
				if (this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type && this.selectdItem
					.compontChildren[0].layoutConfig.classFiyConfig.border.color) {
					let style = {}
					style.borderTop =
						`${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type} ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize[0]}px ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.color}`
					style.borderLeft =
						`${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type} ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize[1]}px ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.color}`
					style.borderBottom =
						`${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type} ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize[2]}px ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.color}`
					style.borderRight =
						`${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type} ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize[3]}px ${this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.color}`
					console.log('getBorderstyle', style)
					return style
				}
			},

			getCheckboxColor(selected) {
				if (selected) {
					return this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySelectdColor
				} else {
					return this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiyColor
				}
			},


			getColor(data) {
				if (this.selectCategoriesId == data.url_name) {
					return this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySelectdColor
				} else {
					return this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiyColor
				}
			},
			getColumns() {
				let num = 1
				if (this.equipment == 'pc') {
					num = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.pcNum
				} else {
					num = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneNum
				}

				let gridRowGap;
				let gridColumnGap;
				if (this.equipment == 'pc') {
					gridRowGap = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.rowGap + 'px'
					gridColumnGap = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap + 'px'
				} else {
					gridRowGap = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneRowGap + 'px'
					gridColumnGap = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneColumnGap + 'px'
				}
				return {
					gridRowGap: gridRowGap,
					gridColumnGap: gridColumnGap,
					gridTemplateColumns: `repeat(auto-fill, calc(${parseInt(100 / num)}% - ${this.equipment == 'pc'?this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap: this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneColumnGap}px))`
				}
			},
			handleNodeClick(e) {
				this.show = false
				console.log('handleNodeClick', e)
				this.selectCategoriesId = e.url_name
				this.url_name = e.url_name
				this.searchParms.page = 1
				this.searchParms.price = ''
				this.price = []
				if (this.type == 'build') {
					this.$emit('changePage', ('/categories/' + e.url_name))
					// this.$router.push({
					// 	path: '/categories/' + e.url_name
					// })
				}
				this.getGoods(e.url_name,'handleNodeClick')
			},
			// 测试数据
			async getData(url_name) {
				try {
					this.loading = true
					let obj = {
						...this.searchParms
					}
					if (!obj.price) {
						delete obj.price
					}
					if (!obj.attr) {
						delete obj.attr
					}
					let classifyData;
					if (this.type != 'build') {
						let wsid = this.$cookies.get("wsid")
						classifyData = await getDesignGetAllCategory({
							wsid,
							...obj
						})
					} else {
						classifyData = await getSetDesignCategoriesData({
							url_name,
							...obj
						})
					}

					this.classifyData = classifyData.data.data
					this.prices = []
					this.prices.push(this.classifyData.filter_data.price.select_min)
					this.prices.push(this.classifyData.filter_data.price.select_max)
					console.log('pricesprices', this.prices)

					if (this.type != 'build') {
						this.classifyData.all_categories.forEach(item => {
							if (this.classifyData.category.id == item.id) {
								this.url_name = item.url_name
								this.selectCategoriesId = this.url_name
							}
						})
					}
					this.goodsDataList = classifyData.data.data.products.data
					this.total = classifyData.data.data.products.total
					console.log('this.classifyData', this.classifyData)
					this.loading = false
					this.$nextTick(() => {
						this.show = true
					})
				} catch (e) {
					console.log('catchee', e)
					this.loading = false
				}
			},
			async getGoods(url_name,type) {
				try {
					// this.goodsDataList = []
					this.loading = true
					let wsid = this.$cookies.get("wsid")

					let obj = {
						...this.searchParms
					}
					if (!obj.price) {
						delete obj.price
					}

					if (!obj.attr) {
						delete obj.attr
					}
					let data;

					if (this.type != 'build') {
						data = await getDesignGetAllCategory({
							url_name,
							wsid,
							...obj
						})
					} else {
						if(type != 'handleNodeClick'){
							
							data = await getSetDesignCategoriesData({
								url_name,
								...obj
							})
							window.scrollTo({
								top:0
							})
						}
						
					}

					this.prices = []
					this.prices.push(data.data.data.filter_data.price.select_min)
					this.prices.push(data.data.data.filter_data.price.select_max)
					console.log('pricesprices', this.prices)

					this.per_pages = data.data.data.per_pages
					this.goodsDataList = data.data.data.products.data
					this.total = data.data.data.products.total
					console.log('this.total', this.total)
					this.$nextTick(() => {
						this.$emit('changeData')
					})
					console.log('data', data)
					this.loading = false
					this.show = true
				} catch (e) {
					this.loading = false
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	::v-deep .el-tree-node__content:hover {
		background-color: transparent !important;
	}

	::v-deep .no-hover-tree .el-tree-node__content:hover {
		background-color: transparent !important;
	}

	// 修改悬停颜色
	::v-deep .el-tree {
		background-color: rgb(0 0 0 / 0%);

		.el-tree-node__content:hover {
			background-color: rgb(0 0 0 / 0%);
		}

		// 修改选中颜色
		.el-tree-node.is-current>.el-tree-node__content {
			background-color: rgb(0 0 0 / 0%);
			// color: #1890ff;
		}

		// 修改选中节点的高亮颜色
		.el-tree-node:focus>.el-tree-node__content {
			background-color: rgb(0 0 0 / 0%);
		}
	}

	::v-deep .el-pager {

		.active {
			color: var(--selectColor);
		}

		li:hover {
			color: var(--hoverColor);
		}

		li {
			background-color: rgb(0 0 0 / 0%);
		}
	}

	::v-deep .el-pagination {
		.btn-prev {
			background-color: rgb(0 0 0 / 0%);
		}

		.btn-next {
			background-color: rgb(0 0 0 / 0%);
		}

		button:hover {
			color: var(--hoverColor);
		}
	}

	::v-deep .el-slider__button {
		width: 10px;
		height: 10px;
		border: solid 1px var(--sliderColor);
	}

	::v-deep .el-slider__bar {
		background-color: var(--sliderColor);
		height: 4px;
		margin-top: 1px;
	}

	::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
		color: var(--checkboxColor)
	}

	::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: var(--checkboxColor);
		border: solid 1px var(--checkboxColor);
	}

	::v-deep .el-checkbox__inner:hover {
		border: solid 1px var(--checkboxColor);
	}
</style>